import React from "react"
import styled from "styled-components"
import {
	StepContent,
	StepTitle,
	StepImage,
	Container,
	Col,
	MobileImage,
	MobileTitle,
	MobileContent,
	MobileContainer,
} from "./Steps.styles"

export const Steps = ({ data }) => {
	const { items } = data

	return (
		<>
			{items.map((step, i) => {
				return (
					<>
						<LeftAlign
							name={step.step_align}
							url={step.step_image?.url}
							title={step.step_title[0]?.text}
							content={step.step_content[0]?.text}
						></LeftAlign>
						<RightAlign
							name={step.step_align}
							url={step.step_image?.url}
							title={step.step_title[0]?.text}
							content={step.step_content[0]?.text}
						></RightAlign>
						<MobileContainer>
							<MobileImage src={step.step_image?.url}></MobileImage>
							<MobileTitle>{step.step_title[0]?.text}</MobileTitle>
							<MobileContent>{step.step_content[0]?.text}</MobileContent>
						</MobileContainer>
					</>
				)
			})}
		</>
	)
}

function LeftAlign(props) {
	if (props.name == "Left") {
		return (
			<>
				<Container>
					<Col style={{ marginRight: "50px" }}>
						<StepTitle>{props.title}</StepTitle>
						<StepContent>{props.content}</StepContent>
					</Col>
					<StepImage src={props.url}></StepImage>
				</Container>
			</>
		)
	} else {
		return false
	}
}

function RightAlign(props) {
	if (props.name == "Right") {
		return (
			<>
				<Container>
					<StepImage src={props.url}></StepImage>
					<Col style={{ marginLeft: "50px" }}>
						<StepTitle>{props.title}</StepTitle>
						<StepContent>{props.content}</StepContent>
					</Col>
				</Container>
			</>
		)
	} else {
		return false
	}
}
